import i18n from "../constants/i18n";

export default props => {
  return (
    <div
      onClick={props.click}
      className="ArrowToTop"
      style={{
        zIndex: 1000,
        cursor:'pointer',
        position: "absolute",
        //top: '0.5rem',
       // right: 0,
        height: "2.5rem",
        // width: "2.5rem",
        // backgroundColor: "#BFC1D1",
        borderRadius: ".5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
        // paddingTop: '0.6rem',
      }}
    >
      <div
        className={"arrow2"}
        style={{
          height: "1.5rem",
          width: "1.5rem",
          marginTop: ".6rem",
          marginRight: "1rem"
        }}
      />
      <span>{i18n.t("GoToTop")}</span>
    </div>
  );
};
